import { useQuery } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import { getCombosHardware } from '~/services-v2/installation-api/installation-api'

export default function useCombosHardware(
  projectId: Ref<string>,
  systemType: string | null,
  isComboConecte: boolean,
  options?: { enabled?: ComputedRef<boolean> },
) {
  const queryFn = async () => {
    return await getCombosHardware(projectId.value, systemType, isComboConecte)
  }

  return useQuery({
    queryFn,
    queryKey: queryKeys.INSTALLATION.COMBOS_HARDWARE(projectId),
    retry: 3,
    staleTime: 1000 * 60 * 1,
    enabled: options?.enabled,
  })
}
